export default {
  common: {
    appName: 'Ttaechang',
    loading: 'Loading...',
    error: 'An error occurred',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    confirm: 'Confirm',
    close: 'Close',
    search: 'Search',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    welcome: 'Welcome',
    logout: 'Logout',
    login: 'Login',
    signup: 'Sign Up',
    and: 'and'
  },
  header: {
    home: 'Home',
    search: 'Search',
    playlists: 'Playlists',
    community: 'Community',
    fanchantArchive: 'Fanchant Archive',
    concerts: 'Concerts',
    practice: 'Practice',
    profile: 'Profile',
    admin: 'Admin',
    bookmarks: 'Bookmarks',
    announcements: 'Announcements',
    myPlaylists: 'My Playlists',
    newPlaylist: 'New Playlist'
  },
  home: {
    title: '🎯 Special Music Experience with Ttaechang',
    subtitle: 'From K-POP, Ballads to Trot!',
    subtitle2: 'Create your own playlists and share them with friends.',
    startButton: 'Get Started →',
    feature1: 'Unlimited Playlist Creation',
    feature2: '30-Second Section Practice Mode',
    feature3: 'Share Playlists with Friends',
    myPlaylists: '{name}\'s Playlists',
    defaultUser: 'User',
    guide: 'Guide',
    noPlaylists: 'No playlists yet. Create a new playlist!',
    popularPlaylists: '🔥 Top 10 Popular Playlists',
    recentPlaylists: '🆕 Recently Created Playlists',
    sortByPlays: 'Plays',
    sortByCopies: 'Copies',
    songs: 'songs',
    songCount: 'Songs',
    copyCount: 'Copies',
    updatedAt: 'Updated',
    share: 'Share',
    plays: 'plays',
    copies: 'copies',
    by: 'by',
    viewDetail: '👁️ View Detail',
    copyPlaylist: '📋 Copy'
  },
  search: {
    title: 'Search Songs',
    tabMusic: '🎵 Music/Video Search',
    tabPopular: '🔥 Popular Playlists',
    tabTags: '🏷️ Search by Tags',
    guide: 'Guide',
    placeholder: 'Search for song title, artist',
    placeholderTag: 'Search playlists by tags',
    searching: 'Searching...',
    noResults: 'No results found',
    tryAgain: 'Try with different keywords',
    recentSearches: 'Recent Searches',
    addToPlaylist: 'Add to Playlist',
    quotaExceeded: 'YouTube API quota exceeded',
    tryLater: 'Please try again later',
    todaySearch: 'Today\'s searches',
    remaining: 'Remaining',
    times: 'times',
    quotaExhausted: '⚠️ Search quota exhausted',
    linkGuideTitle: '💎 Unlimited Search Tip!',
    linkGuideTitleExceeded: 'Ran out of searches?',
    linkGuideText: 'Enter YouTube link directly to add',
    linkGuideHighlight: 'without consuming searches',
    linkGuideHighlightExceeded: 'without quota deduction',
    linkGuideText2: 'search directly!',
    linkGuideExample: 'Example: https://www.youtube.com/watch?v=videoId or https://youtu.be/videoId',
    filterTitle: 'Search Type (Multiple selection):',
    filterOfficial: 'Official',
    filterLyrics: 'Lyrics',
    filterLive: 'Live',
    filterCover: 'Cover',
    filterAudio: 'Audio',
    allPlaylists: 'All Playlists',
    myPlaylists: 'My Playlists',
    popularTags: '🔥 Popular Tags',
    recommendedKeywords: '🔍 Recommended Keywords',
    recentSearchesTitle: 'Recent Searches',
    popularKeywords: 'Popular Keywords',
    noRecentSearches: 'No recent searches',
    quotaCacheMessage: 'Click on the following keywords to view cached results:',
    noCacheData: 'No cached data available. Try different keywords.',
    // Search method tabs
    searchByKeyword: 'Keyword Search',
    searchByLink: 'Search by Link',
    // URL input
    urlPlaceholder: 'Enter YouTube link (e.g., https://www.youtube.com/watch?v=...)',
    addToPlayer: 'Add to Player',
    urlHelp: 'Supports YouTube and YouTube Music links. Link search does not consume quota.',
    loading: 'Loading...',
    // Alert messages
    alertInvalidUrl: 'Invalid YouTube URL.',
    alertVideoInfoFailed: 'Failed to fetch video information.',
    alertSongAddedToPlayer: 'Added to player.',
    alertSongAddFailed: 'Failed to add song'
  },
  playlist: {
    title: 'Playlist',
    type: 'Playlist',
    loading: 'Loading playlist...',
    retry: 'Retry',
    backToList: 'Back to List',
    backToListShort: '← Back',
    guide: 'Guide',
    myPlaylists: 'My Playlists',
    publicPlaylists: 'Public Playlists',
    createNew: 'New Playlist',
    editPlaylist: 'Edit Playlist',
    deletePlaylist: 'Delete Playlist',
    playlistName: 'Playlist Name',
    description: 'Description',
    descriptionPlaceholder: 'Enter playlist description...',
    isPublic: 'Public',
    isPrivate: 'Private',
    clickToPublic: 'Click to make public',
    clickToPrivate: 'Click to make private',
    editTitle: 'Edit title',
    editDescription: 'Edit description',
    songs: 'songs',
    addSongs: 'Add Songs',
    removeSong: 'Remove Song',
    playSong: 'Play',
    playAll: 'Play All',
    shuffle: 'Shuffle',
    confirmDelete: 'Are you sure you want to delete?',
    emptySongList: 'No songs',
    addFirstSong: 'Add your first song',
    createdBy: 'Created by',
    totalDuration: 'Total duration',
    songList: 'Song List',
    saveBtn: 'Save',
    cancelBtn: 'Cancel',
    totalCopies: 'Total Copies',
    times: 'times',
    share: 'Share',
    shareDropdown: 'Share ▼',
    shareToCommunity: 'Share to Community',
    unshareToCommunity: 'Unshare from Community',
    copyLink: 'Copy Link',
    copyToMyPlaylist: 'Copy to My Playlist',
    privatePlaylist: 'Private Playlist',
    shareOnlyPublic: 'Only public playlists can be shared',
    tags: 'Tags',
    comments: 'Comments',
    showComments: 'Show Comments',
    hideComments: 'Hide Comments',
    sortBy: 'Sort:',
    sortCustom: 'Custom Order',
    sortTitle: 'By Title',
    sortArtist: 'By Artist',
    sortAddedDate: 'By Date Added',
    sortDuration: 'By Duration',
    tableTitle: 'Title',
    tableArtist: 'Artist',
    tableAlbum: 'Album',
    tableAddedDate: 'Date Added',
    tableDuration: 'Duration',
    addToQueueNext: 'Add next to current',
    addToQueueLast: 'Add to end of queue',
    removeFromPlaylist: 'Remove from playlist',
    emptyPlaylist: 'Playlist is empty',
    addSongsToStart: 'Add songs to get started',
    recentActivity: 'Recent Activity',
    copyPlaylistModal: 'Copy Playlist',
    copyPlaylistConfirm: 'Copy this playlist to your playlists?',
    copyWarning: 'The copied playlist will be added to your playlist collection.',
    copyBtn: 'Copy',
    addSongModal: 'Add Song',
    addBySearch: 'Add by Search',
    addByLink: 'Add by Link',
    searchPlaceholder: 'Search by artist or song name...',
    todaySearches: 'Today\'s Searches:',
    remaining: 'Remaining:',
    quotaExhausted: 'Search Quota Exhausted',
    linkAddTip: 'Unlimited Search Tip!',
    linkAddTipExhausted: 'Ran out of searches?',
    linkAddDesc1: 'Use Add by Link tab to add',
    linkAddHighlight: 'without quota deduction',
    linkAddHighlightAlt: 'without consuming searches',
    linkAddDesc2: 'directly!',
    linkAddInstruction: 'Select "🔗 Add by Link" tab above',
    urlPlaceholder: 'Enter YouTube URL... (e.g., https://www.youtube.com/watch?v=...)',
    urlSupport: 'YouTube and YouTube Music links supported',
    searchResults: 'Search Results',
    items: 'items',
    viewCount: 'views',
    prevPage: 'Previous',
    nextPage: 'Next',
    pageInfo: 'Page',
    searching: 'Searching...',
    noResults: 'No results found',
    closeModal: 'Close',
    loading: 'Loading...',
    // Additional translations for script messages
    hour: 'hour',
    minute: 'min',
    noDescription: 'No description.',
    // Alert messages
    alertTitleRequired: 'Playlist title cannot be empty.',
    alertUpdateFailed: 'Failed to update playlist.',
    alertSongsAddedToQueue: '{count} song(s) added to queue',
    alertSongsAddedShuffled: '{count} song(s) added to queue (shuffled)',
    alertSongRemoveFailed: 'Failed to remove song.',
    alertSharedToCommunity: 'Playlist shared to community!',
    alertUnsharedFromCommunity: 'Community sharing cancelled.',
    alertCommunityShareFailed: '❌ Failed to process community sharing.',
    alertPlaylistCopied: '"{name}" playlist copied to your playlists!',
    alertCannotCopyOwn: 'Cannot copy your own playlist.',
    alertCopyFailed: '❌ Failed to copy playlist.',
    alertMadePublic: '✅ Playlist made public!\nYou can now share it.',
    alertMakePublicFailed: '❌ Failed to make playlist public.',
    alertPrivacyChangedPublic: '🌍 Playlist made public!\nOthers can now view and you can share it.',
    alertPrivacyChangedPrivate: '🔒 Playlist made private!\nOnly you can view it now.',
    alertPrivacyChangeFailed: '❌ Failed to change playlist privacy.',
    alertDeleted: 'Playlist deleted successfully.',
    alertDeleteFailed: 'Failed to delete playlist.',
    alertSearchFailed: 'Search failed: {message}',
    alertSongAdded: '✅ "{title}" added to playlist.',
    alertSongAddFailed: 'Failed to add song: {message}',
    alertInvalidUrl: 'Invalid YouTube URL.',
    alertVideoInfoFailed: 'Failed to get video info: {status}',
    // Confirm messages
    confirmRemoveSong: 'Remove this song from the playlist?',
    confirmClearPlaylist: 'Delete all songs from this playlist?',
    confirmDeletePlaylist: 'Permanently delete "{name}" playlist?\n\nThis action cannot be undone.',
    confirmMakePublic: '🔒 This playlist is private.\n\nTo share it, you need to make it public.\n\nMake it public now?',
    confirmPrivacyChange: 'Change playlist from {currentStatus} to {newStatus}?\n\n{details}',
    privacyDetailsPublic: '• Making it public allows others to view this playlist.\n• You can generate share links.',
    privacyDetailsPrivate: '• Making it private hides it from others.\n• Existing share links will show "Private Playlist" notice.',
    statusPublic: 'public',
    statusPrivate: 'private',
    // Error messages
    errorNotFound: '❌ Playlist not found.',
    errorForbidden: '🔒 You don\'t have permission to access this playlist.',
    errorServerError: '⚠️ Server error occurred. Please try again later.',
    errorLoadFailed: '❌ Failed to load playlist.',
    errorNetworkFailed: '🌐 Please check your network connection.'
  },
  player: {
    play: 'Play',
    pause: 'Pause',
    previous: 'Previous',
    next: 'Next',
    repeat: 'Repeat',
    shuffle: 'Shuffle',
    volume: 'Volume',
    selectSong: 'Select a song to play',
    playlist: 'Playlist',
    songsCount: 'songs',
    clearAll: 'Clear all',
    removeFromPlaylist: 'Remove from playlist',
    lyrics: 'Lyrics',
    subtitle: 'Subtitle',
    noSubtitle: 'No subtitle',
    sections: 'Sections',
    sectionManagement: 'Section Management',
    addSection: 'Add Section',
    sectionSelect: 'Select Section',
    sectionSelecting: '📐 Selecting...',
    selectedSection: 'Selected Section',
    sectionRepeat: 'Section Repeat',
    sectionRepeating: 'Repeating',
    saveSection: 'Save Section',
    deleteSection: 'Delete Selected Section',
    sectionSaveModal: '🎵 Save Section',
    sectionName: 'Section Name',
    sectionNamePlaceholder: 'e.g., Chorus, Bridge, Killing Part',
    sectionLyrics: 'Lyrics/Subtitle',
    sectionLyricsPlaceholder: 'Enter lyrics you want to sing along',
    pronunciation: 'Pronunciation',
    pronunciationPlaceholder: 'Add pronunciation guide for non-Korean lyrics',
    required: '*',
    cancel: 'Cancel',
    save: 'Save',
    startTime: 'Start Time',
    endTime: 'End Time',
    noLyrics: 'No lyrics available',
    loading: 'Loading...',
    player: 'Player',
    openPlayer: 'Open Player',
    closePlayer: 'Close Player',
    expandFullscreen: 'Expand to fullscreen',
    closeFullscreen: 'Close fullscreen',
    clearAllPlaylist: 'Clear All',
    selectSongPlaceholder: 'Please select a song',
    artist: 'Artist',
    upcomingSection: 'sec remaining',
    section: 'Section',
    sectionTime: 'Section:',
    repeatMode: 'Repeat',
    deleteBtn: 'Delete',
    saveBtn: 'Save',
    lyricsSaveModal: '🎤 Save Lyrics Section',
    lyricsEditModal: '🎤 Edit Lyrics Section',
    lyricsText: 'Lyrics',
    lyricsTextPlaceholder: 'Enter lyrics for this section',
    pronunciationGuide: 'Pronunciation Guide',
    pronunciationGuidePlaceholder: 'Add pronunciation guide for non-Korean lyrics',
    lineNumber: 'Line Number',
    lineNumberPlaceholder: 'Order of lyrics (for sorting)',
    shareWithOthers: 'Share with other users',
    confirmRemoveSong: 'Remove this song from the player?',
    confirmClearPlaylist: 'Clear entire playlist?',
    confirmDeleteLyrics: 'Delete lyrics section "{name}"?',
    alertLyricsRequired: 'Please enter lyrics section name and lyrics.',
    alertLyricsUpdated: 'Lyrics section "{name}" has been updated!',
    alertLyricsSaved: 'Lyrics section "{name}" has been saved!',
    alertLyricsSaveFailed: 'Failed to save lyrics section. Please try again.',
    alertLyricsDeleted: 'Lyrics section "{name}" has been deleted.',
    alertLyricsDeleteFailed: 'Failed to delete lyrics section. Please try again.',
    errorInvalidVideo: 'Invalid video ID',
    errorHtml5: 'Content cannot be played in HTML5 player',
    errorNotFound: 'Video not found (deleted or private)',
    errorEmbedNotAllowed: 'Video owner does not allow embedding',
    errorUnknown: 'Unknown error',
    errorCode: 'Code'
  },
  profile: {
    title: 'Profile',
    loading: 'Loading profile...',
    error: 'An error occurred',
    retry: 'Retry',
    changeImage: '📷 Change Image',
    nickname: 'Nickname',
    nicknameDefault: 'Set your nickname',
    nicknamePlaceholder: 'Enter nickname',
    save: 'Save',
    cancel: 'Cancel',
    username: 'Username',
    email: 'Email',
    emailNotRegistered: 'Email not registered',
    emailNotification: 'Email Notification',
    provider: 'OAuth Provider',
    createdAt: 'Joined',
    lastLoginAt: 'Last Login',
    profileImage: 'Profile Image',
    updateProfile: 'Update Profile',
    updateSuccess: 'Profile updated successfully',
    updateFailed: 'Failed to update profile',
    nicknameUpdateSuccess: 'Nickname saved',
    nicknameUpdateFailed: 'Failed to save nickname',
    imageUpdateSuccess: 'Profile image updated',
    imageUpdateFailed: 'Failed to upload image'
  },
  admin: {
    dashboard: 'Dashboard',
    stats: 'Service Statistics',
    users: 'User Management',
    playlists: 'Playlists',
    reports: 'Comment Reports',
    announcements: 'Announcements',
    concerts: 'Concert Info',
    settings: 'System Settings',
    backToUser: 'Back to User Page',
    searchStats: 'Search Statistics',
    apiUsage: 'API Usage',
    userActivity: 'User Activity',
    contentStats: 'Content Statistics',
    popularQueries: 'Popular Queries',
    cacheHitRate: 'Cache Hit Rate',
    dailySearches: 'Daily Searches',
    totalApiCalls: 'Total API Calls',
    avgDailyUsage: 'Avg Daily Usage',
    quotaUsageRate: 'Quota Usage Rate',
    dau: 'DAU',
    wau: 'WAU',
    mau: 'MAU',
    newUsers: 'New Users',
    activeUsers: 'Active Users',
    totalPlaylists: 'Total Playlists',
    totalSongs: 'Total Songs',
    publicRate: 'Public Rate',
    period: 'Period',
    days7: '7 Days',
    days14: '14 Days',
    days30: '30 Days',
    days90: '90 Days'
  },
  concerts: {
    title: 'Concert Information',
    upcoming: 'Upcoming Concerts',
    past: 'Past Concerts',
    date: 'Date',
    venue: 'Venue',
    artist: 'Artist',
    tickets: 'Book Tickets',
    noUpcoming: 'No upcoming concerts',
    guide: 'Guide',
    guideTitle: 'Usage Guide',
    domestic: 'Domestic Concerts',
    global: 'Global Concerts',
    dateSelect: 'Select Date:',
    today: 'Today',
    concertsCount: 'concerts',
    page: 'Page',
    total: 'Total',
    items: 'items',
    gridView: 'Grid',
    listView: 'List',
    loading: 'Loading concert information...',
    venueUndecided: 'Venue TBD',
    createPlaylist: 'Create Playlist',
    bookTickets: 'Book Tickets',
    noConcerts: 'No concerts on selected date',
    tryOtherDate: 'Try selecting a different date',
    prev: 'Previous',
    next: 'Next',
    playlistModal: 'Create Playlist',
    playlistName: 'Playlist Name',
    playlistNamePlaceholder: 'Playlist',
    searchKeyword: 'Search Keyword',
    searchKeywordPlaceholder: 'Enter search keyword',
    searching: 'Searching...',
    search: 'Search',
    quotaExceededTitle: 'YouTube API quota exceeded',
    quotaExceededDesc: 'Click on a recommended keyword to view cached results:',
    quotaExceededNoCache: 'No cached data available. Try different keywords.',
    recommendedQueries: 'Recommended Keywords',
    searchResults: 'Search Results',
    songs: 'songs',
    add: 'Add',
    remove: 'Remove',
    loadingMore: 'Loading...',
    loadMore: 'Load More',
    currentPlaylist: 'Playlist',
    cancel: 'Cancel',
    saving: 'Saving...',
    savePlaylist: 'Save Playlist',
    playlistModalTitle: 'Create {title} Playlist',
    alertEnterKeyword: 'Please enter search keyword.',
    alertSearchError: 'An error occurred while searching.',
    alertRecommendedError: 'An error occurred while loading recommended keywords.',
    alertAddSongs: 'Please add songs to the playlist.',
    alertEnterName: 'Please enter playlist name.',
    alertPlaylistSaved: 'Playlist "{name}" created successfully! ({count} songs)',
    alertPlaylistError: 'An error occurred while saving the playlist.',
    statusOnSale: 'On Sale',
    statusSoldOut: 'Sold Out',
    statusUpcoming: 'Upcoming',
    statusEnded: 'Ended'
  },
  practice: {
    title: 'Practice Mode',
    selectSong: 'Select a song',
    selectSection: 'Select a section to practice',
    startPractice: 'Start Practice',
    repeat: 'Repeat Count',
    speed: 'Playback Speed',
    normal: 'Normal',
    slow: 'Slow',
    fast: 'Fast'
  },
  auth: {
    loginTitle: 'Login',
    signupTitle: 'Sign Up',
    loginWithGoogle: 'Login with Google',
    loginWithNaver: 'Login with Naver',
    loginWithKakao: 'Login with Kakao',
    loginRequired: 'Login required',
    loginSuccess: 'Logged in successfully',
    logoutSuccess: 'Logged out successfully',
    // Login modal
    welcomeTitle: 'Welcome to Ttaechang!',
    welcomeSubtitle: 'Log in easily and create your own playlists',
    simpleLogin: 'Easy Login',
    startWithGoogle: 'Start with Google',
    startWithNaver: 'Start with Naver',
    guestMode: 'Try Guest Mode',
    guestNotice: '※ This is a temporary feature provided for YouTube API review and demo purposes',
    loginAgreement: 'By logging in, you agree to our',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    agreementSuffix: '.',
    // Multi-login confirmation
    multiLoginTitle: 'Account already logged in',
    multiLoginMessage1: 'You are currently logged in on another device.',
    multiLoginMessage2: 'If you continue, the existing login will be automatically logged out.',
    existingSessions: 'Existing login sessions:',
    deviceWeb: 'Web Browser',
    deviceMobile: 'Mobile App',
    minutesAgo: '{minutes} minutes ago',
    hoursAgo: '{hours} hours ago',
    daysAgo: '{days} days ago',
    cancelBtn: 'Cancel',
    forceLoginBtn: 'Log out existing session and continue'
  },
  footer: {
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    youtubeTerms: 'YouTube Terms of Service',
    googlePrivacy: 'Google Privacy Policy',
    copyright: '© 2025 Ttaechang. All rights reserved.',
    youtubeApiNotice: 'This service uses YouTube API Services.',
    madeBy: 'Made by:',
    contact: 'Contact:'
  },
  playlistList: {
    title: 'My Playlists',
    subtitle: 'Create and manage your fanchant playlists',
    createBtn: 'Create New Playlist',
    statTotal: 'Total Playlists',
    statSongs: 'Total Songs',
    statPublic: 'Public Playlists',
    statCopies: 'Total Copies',
    viewGrid: 'Grid',
    viewList: 'List',
    sortRecent: 'Recently Modified',
    sortName: 'By Name',
    sortSongs: 'By Song Count',
    sortCreated: 'By Creation Date',
    filterAll: 'All',
    filterPublic: 'Public',
    filterPrivate: 'Private',
    searchPlaceholder: 'Search playlists...',
    loading: 'Loading playlists...',
    retryBtn: 'Retry',
    songs: 'songs',
    public: 'Public',
    private: 'Private',
    tooltipEdit: 'Edit',
    tooltipShare: 'Share',
    tooltipDelete: 'Delete',
    tablePlaylist: 'Playlist',
    tableSongCount: 'Song Count',
    tablePublicSetting: 'Privacy',
    tableUpdatedDate: 'Modified',
    tableActions: 'Actions',
    noPlaylists: 'No playlists',
    noPlaylistsSub: 'Create your first playlist',
    createPlaylistBtn: 'Create Playlist',
    modalCreate: 'Create New Playlist',
    modalName: 'Playlist Name',
    modalNamePlaceholder: 'e.g., BTS Fanchant Collection',
    modalDescription: 'Description',
    modalDescriptionPlaceholder: 'Write a description for this playlist',
    modalPublicCheckbox: 'Make this playlist public',
    modalTags: 'Tags (comma separated)',
    modalTagsPlaceholder: 'e.g., fanchant, BTS, beginner',
    modalTagsHint: 'Separate multiple tags with commas (,)',
    modalCancel: 'Cancel',
    modalCreate: 'Create',
    // formatDate
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: '{days} days ago',
    weeksAgo: '{weeks} weeks ago',
    unknown: 'Unknown',
    // Activities
    activityCreated: '"{name}" playlist created',
    activityEdited: '"{name}" playlist edited',
    activityShared: '"{name}" playlist shared',
    activityNone: 'No activity yet',
    activityNoneSub: 'Create a playlist!',
    // Alerts
    alertDeleteConfirm: 'Delete "{name}" playlist?',
    alertDeleteFailed: 'Failed to delete playlist.',
    alertLoadFailed: 'Failed to load playlists: {message}',
    alertCreateFailed: 'Failed to create playlist',
    alertNoDescription: 'New playlist',
    alertJustNow: 'Just now',
    // Others
    noUserId: 'No user ID',
    loadingSongs: 'Loading songs...',
    noSongInfo: 'No song info',
    unknownArtist: 'Unknown',
    noTitle: 'No title'
  },

  // PlaylistFeed (Community Playlist Feed)
  playlistFeed: {
    title: '🎵 Playlist Community Board',
    description: 'Explore playlists shared by other users and bookmark your favorites',
    searchPlaceholder: 'Search by title, description, author, or tags...',
    searchBtn: '🔍 Search',
    sortRecent: 'Recent',
    sortPopular: 'Popular',
    sortMostLiked: 'Most Liked',
    sortMostViewed: 'Most Viewed',
    sortMostCopied: 'Most Copied',
    sortMostBookmarked: 'Most Bookmarked',
    filterAllSongs: 'All song counts',
    filter5Plus: '5+ songs',
    filter10Plus: '10+ songs',
    filter20Plus: '20+ songs',
    popularTagsTitle: '🏷️ Popular Tags',
    selectedTagsLabel: 'Selected Tags:',
    clearAllTags: 'Clear All',
    loading: 'Loading playlists...',
    retryBtn: 'Retry',
    songs: 'songs',
    noDescription: 'No description',
    authorLabel: 'Author:',
    emptyState: 'No public playlists available',
    prevPage: '◀ Previous',
    nextPage: 'Next ▶',
    loadError: 'Failed to load playlists.',
    bookmarkError: 'Failed to bookmark.',
    thumbnailAlt: 'Song {index} thumbnail'
  },

  // FanchantArchive
  fanchantArchive: {
    title: '🎬 Fanchant Video Archive',
    description: 'Collect touching fanchant moments from K-pop concerts',
    guideBtn: 'Guide',
    guideBtnTooltip: 'User Guide',
    searchPlaceholder: 'Search fanchant videos by artist or song...',
    searchBtn: '🔍 Search',
    tabTrendingShorts: 'Trending Shorts',
    tabTrendingRegular: 'Trending Regular',
    tabPopularShorts: 'Popular Shorts',
    tabPopularRegular: 'Popular Regular',
    tabSearch: 'Search',
    loading: 'Loading fanchant videos...',
    retryBtn: 'Retry',
    totalVideos: 'Total {count} videos',
    displayedVideos: '({displayed} displayed)',
    lastUpdate: 'Last updated: {date}',
    searchResultTitle: '🔍 Search results for "{query}"',
    emptySearch: 'No search results',
    emptySearchSub: 'Try a different search term',
    emptyDefault: 'Search for fanchant videos!',
    emptyDefaultSub: 'Enter an artist name or song title to find touching fanchant moments',
    videoSuffix: 'Fanchant Videos',
    loadTrendingShortsError: 'Failed to load trending shorts fanchant videos.',
    loadTrendingRegularError: 'Failed to load trending regular fanchant videos.',
    loadPopularShortsError: 'Failed to load popular shorts fanchant videos.',
    loadPopularRegularError: 'Failed to load popular regular fanchant videos.',
    searchError: 'Search failed.',
    searchNotFound: 'No fanchant videos found for "{query}". Try a different search term.'
  },

  // Pagination
  pagination: {
    previous: 'Previous',
    next: 'Next',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    itemsCount: '{start}-{end} / {total} items'
  },

  // Comments
  comments: {
    title: '💬 Comments',
    count: '{count}',
    sortLatest: 'Latest',
    sortPopular: 'Popular',
    writePlaceholder: 'Write a comment...',
    cancel: 'Cancel',
    submitting: 'Submitting...',
    submit: 'Post Comment',
    loginRequired: 'Please',
    loginLink: 'login',
    loginRequiredSuffix: 'to write a comment.',
    loading: 'Loading comments...',
    noComments: 'No comments yet.',
    firstComment: 'Be the first to comment!',
    loadMore: 'Load More Comments',
    replyTitle: 'Write Reply',
    replyTo: 'Reply to {name}',
    replyPlaceholder: 'Write a reply...',
    replySubmitting: 'Submitting...',
    replySubmit: 'Post Reply',
    reportTitle: 'Report Comment',
    reportReason: 'Reason',
    reportReasonPlaceholder: 'Select a reason',
    reportReasonSpam: 'Spam',
    reportReasonAbuse: 'Abusive language',
    reportReasonInappropriate: 'Inappropriate content',
    reportReasonHate: 'Hate speech',
    reportReasonOther: 'Other',
    reportDescription: 'Description (optional)',
    reportDescriptionPlaceholder: 'Please provide details about your report...',
    reportSubmitting: 'Reporting...',
    reportSubmit: 'Submit Report',
    alertLoginRequired: 'Login required.',
    alertCommentFailed: 'Failed to post comment.',
    alertReplyFailed: 'Failed to post reply.',
    alertEditFailed: 'Failed to edit comment.',
    alertDeleteConfirm: 'Are you sure you want to delete this comment?',
    alertDeleteFailed: 'Failed to delete comment.',
    alertReportSuccess: 'Your report has been submitted.',
    alertReportFailed: 'Failed to submit report.'
  },

  // Announcements
  announcements: {
    title: 'Announcements',
    loading: 'Loading announcements...',
    noAnnouncements: 'No announcements available.',
    readMore: 'Read more',
    back: 'Back',
    backToList: 'Back to list',
    notFound: 'Announcement not found.',
    loadError: 'Failed to load announcements.'
  }
}
